<template>
  <!-- (拟设)基金 - 公司类型表单面板(弹窗编辑/回显平铺 复用) -->
  <el-form
    ref="formRef"
    :model="form"
    :rules="rules"
    label-position="top"
    :disabled="isReadonly"
    :class="{ readOnlyStyle: isReadonly }"
    class="companyForm"
  >
    <div class="postType">
      <el-form-item>
        <el-radio-group v-model="form.positionHeld">
          <el-radio label="SHAREHOLDER">{{ $t("enroll.intitle.type01") }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </div>
    <el-row :gutter="20" class="pt22">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.licenseName')" prop="fullName" ref="fullName">
          <el-input v-model="form.fullName" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.country')" prop="nationality" ref="nationality">
          <el-select v-model="form.nationality" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
            <el-option v-for="item of globalFormatList('countryList')" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.license')" prop="businessLicenseNo" ref="businessLicenseNo">
          <el-input v-model="form.businessLicenseNo" :placeholder="$t('common.placeholder.enter')" v-regexFilter="$halfWidthRegex" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.phone')" prop="phone" ref="phone">
          <prefix-phone v-model="form.phone" class="wdb100"></prefix-phone>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.email')" prop="email" ref="email">
          <el-input v-model="form.email" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.site')" prop="registeredOfficeAddress" ref="registeredOfficeAddress">
          <el-input v-model="form.registeredOfficeAddress" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.location')" prop="operationAddress" ref="operationAddress">
          <el-input v-model="form.operationAddress" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.incorporationDate')" prop="incorporationDate" ref="incorporationDate">
          <el-date-picker
            v-model="form.incorporationDate"
            type="date"
            :placeholder="$t('common.placeholder.select')"
            value-format="yyyy-MM-dd"
            class="wdb100"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.isNomineeShareholder')" prop="isNominatedShareholder" ref="isNominatedShareholder">
          <el-select v-model="form.isNominatedShareholder" :placeholder="$t('common.placeholder.select')" class="wdb100">
            <el-option :value="1" :label="$t('common.yes')"></el-option>
            <el-option :value="0" :label="$t('common.no')"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.theFundsName')" prop="fundsInfo" ref="fundsInfo">
          <el-select v-model="form.fundsInfo" multiple :placeholder="$t('common.placeholder.select')" filterable value-key="fundName" class="wdb100">
            <el-option v-for="(item, idx) in fundInfoList" :label="item.fundName" :key="`companyKey-${idx}`" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- representative (主体代表) -->
    <div class="wdb100 pt20" v-if="form.positionHeld === 'SHAREHOLDER'">
      <div class="lh40 fs13 black45 fwb postType">{{ $t("enroll.intitle.representative") }}</div>
      <el-row :gutter="20" class="pt22">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.cardName')" prop="representativeInfo.fullName" ref="representativeInfo.fullName">
            <el-input v-model="form.representativeInfo.fullName" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.nationality')" prop="representativeInfo.nationality" ref="representativeInfo.nationality">
            <el-select v-model="form.representativeInfo.nationality" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
              <el-option v-for="item of globalFormatList('nationalityList')" :key="`reprNat-${item.value}`" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.cardType')" prop="representativeInfo.identificationType" ref="representativeInfo.identificationType">
            <el-select v-model="form.representativeInfo.identificationType" :placeholder="$t('common.placeholder.select')" class="wdb100">
              <el-option v-for="item of byCountryFormatList('identificationData')" :key="`reprId-${item.value}`" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.cardNo')" prop="representativeInfo.identificationNo" ref="representativeInfo.identificationNo">
            <el-input
              v-model="form.representativeInfo.identificationNo"
              :placeholder="$t('common.placeholder.enter')"
              v-regexFilter="$halfWidthRegex"
              class="wdb100"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.phone')" prop="representativeInfo.phone" ref="representativeInfo.phone">
            <prefix-phone v-model="form.representativeInfo.phone" class="wdb100"></prefix-phone>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.email')" prop="representativeInfo.email" ref="representativeInfo.email">
            <el-input v-model="form.representativeInfo.email" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.address')" prop="representativeInfo.residentialAddress" ref="representativeInfo.residentialAddress">
            <el-input v-model="form.representativeInfo.residentialAddress" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('enroll.intitle.birthDate')" prop="representativeInfo.birthDate" ref="representativeInfo.birthDate">
            <el-date-picker
              v-model="form.representativeInfo.birthDate"
              type="date"
              :placeholder="$t('common.placeholder.select')"
              value-format="yyyy-MM-dd"
              class="wdb100"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <!-- 股份信息表格 -->
    <shares-table :value="form" @input="handleSharesInput" :fundInfoList="fundInfoList" :isReadonly="isReadonly" />
  </el-form>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import SharesTable from "./SharesTable.vue";
import { validateFormLocation } from "@/utils/common";
import { mapState, mapGetters } from "vuex";

// 可选业务类型集合（用于判断字段是否必填）
const OPTIONAL_BUSINESS_TYPES = ["COMPREHENSIVE_CUSTOMIZED", "FUND_ADMIN_CUSTOMIZED"];

export default {
  name: "FundDirectorCompanyFormPanel",
  mixins: [validatorMixin],
  components: { SharesTable },
  props: {
    /** 表单数据对象(弹窗模式: companyForm; 回显模式: 股东/董事row) */
    form: { type: Object, required: true },
    /** 基金信息列表（供关联基金选择） */
    fundInfoList: { type: Array, default: () => [] },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("constant", ["globalFormatList", "byCountryFormatList"]),
    /** 判断当前是否为可选字段模式（COMPREHENSIVE_CUSTOMIZED / FUND_ADMIN_CUSTOMIZED） */
    isOptionalField() {
      return OPTIONAL_BUSINESS_TYPES.includes(this.applymentDetail.businessType);
    },
    rules() {
      const opt = this.isOptionalField;
      return {
        fullName: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        nationality: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        businessLicenseNo: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        phone: [{ required: !opt, validator: this.validatePhone, trigger: "submit" }],
        email: [
          { required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" },
          { type: "email", message: this.$t("common.regular.email"), trigger: "submit" },
        ],
        registeredOfficeAddress: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        operationAddress: [
          { required: opt || this.applymentDetail.businessType === "COMPANY_INCORPORATION" ? false : true, message: this.$t("common.placeholder.enter"), trigger: "submit" },
        ],
        incorporationDate: [{ required: !opt, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        isNominatedShareholder: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        fundsInfo: [
          {
            required: true,
            type: "array",
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        information: [{ required: true, message: this.$t("common.placeholder.replenish"), trigger: "submit" }],
        representativeInfo: {
          fullName: [{ required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
          nationality: [{ required: !opt, message: this.$t("common.placeholder.select"), trigger: "submit" }],
          identificationType: [{ required: !opt, message: this.$t("common.placeholder.select"), trigger: "submit" }],
          identificationNo: [{ required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
          email: [
            { required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" },
            { type: "email", message: this.$t("common.regular.email"), trigger: "submit" },
          ],
          phone: [{ required: !opt, validator: this.validatePhone, trigger: "submit" }],
          residentialAddress: [{ required: !opt, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
          birthDate: [{ required: false, validator: this.validateBirthday, trigger: "submit" }],
        },
      };
    },
  },
  methods: {
    /** 清除校验状态(供父组件通过ref调用) */
    clearValidate() {
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    /** 供父组件触发表单校验 */
    validate(callback) {
      this.$refs.formRef.validate((valid, object) => {
        if (!valid) validateFormLocation(object, this.$refs.formRef);
        callback && callback(valid);
      });
    },
    /**
     * SharesTable 返回深拷贝后的新对象(仅 sharesInfo 变化)，
     * form 是 prop 不能整体替换，将变更同步回原对象以保持父组件引用
     */
    handleSharesInput(val) {
      if (!val) return;
      this.$set(this.form, "sharesInfo", val.sharesInfo || []);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 表单项基础样式(与弹窗内展示保持一致) */
.companyForm ::v-deep {
  .el-form-item__label {
    line-height: 1em;
    padding: 0 0 8px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-radio {
    margin-right: 18px;
  }
  .el-radio:last-child {
    margin-right: 0;
  }
  .el-radio__label {
    padding-left: 5px;
  }
  /* 数字输入框 spinner 隐藏 */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none !important;
  }
  input[type="number"] {
    appearance: textfield !important;
  }
}
.postType {
  width: 100%;
  height: 40px;
  background: #f4f8fe;
  padding: 0 20px;
}
.postType ::v-deep .el-form-item__content {
  line-height: 40px;
}
</style>
